// 服务学校数量是否为无限映射
export const schoolCountLimitedMap = [[false, '无限'], [true, '有限']]
// 保结果映射
export const confirmedResultsMap = [[true, '是'], [false, '否']]
// 导师角色映射
export const mentorRoleEnMap = [
  ['UGDCM', 'College Mentor'],
  ['UGDEM', 'Essay Mentor'],
  ['UGDFAO', 'FAO']
]
export const mentorRoleCnMap = [
  ['UGDCM', '学术导师'],
  ['UGDEM', '文笔导师'],
  ['UGDFAO', '前任招生官']
]
// degree映射
export const degreeMap = [
  ['PHD', 'PhD'],
  ['MASTER', 'Master'],
  ['DPHILL', 'DPhill'],
  ['MPHILL', 'MPhill'],
  ['MSC', 'MSc'],
  ['MSA', 'MSa'],
  ['JD', 'JD'],
  ['MD', 'MD'],
  ['BACHELOR_DEGREE', 'Bachelor Degree'],
  ['OTHER', 'Other']
]
// 视频聊天工具映射
// {id: 'TENCENT', name: 'Zoom视频会议（原有）'}
export const videoMap = [{ id: 'ZOOM', name: 'Zoom视频会议' }]
// 时区映射
export const zoneCnMap2 = [
  ['AEST', '澳大利亚东部标准时间'],
  ['ACST', '澳大利亚中部标准时间'],
  ['AWST', '澳大利亚东西部标准时间'],
  ['BJT', '北京时间'],
  ['EST', '美国东部时间'],
  ['MST', '美国山地时间'],
  ['CST', '美国中部时间'],
  ['PST', '美国西部时间'],
  ['SAST', '南非时间'],
  ['BST', '英国时间'],
  ['FST', '法国时间'],
  ['TST', '泰国时间']
]
export const zoneCnMap = [
  {
    value: 'AEST',
    title: '澳大利亚东部标准时间'
  },
  {
    value: 'ACST',
    title: '澳大利亚中部标准时间'
  },
  {
    value: 'AWST',
    title: '澳大利亚东西部标准时间'
  },
  {
    value: 'BJT',
    title: '北京时间'
  },
  {
    value: 'EST',
    title: '美国东部时间'
  },
  {
    value: 'MST',
    title: '美国山地时间'
  },
  {
    value: 'CST',
    title: '美国中部时间'
  },
  {
    value: 'PST',
    title: '美国西部时间'
  },
  {
    value: 'SAST',
    title: '南非时间'
  },
  {
    value: 'BST',
    title: '英国时间'
  },
  {
    value: 'FST',
    title: '法国时间'
  },
  {
    value: 'TST',
    title: '泰国时间'
  }
]
export const zoneEnMap = [
  {
    value: 'AEST',
    title: 'Australian Eastern Standard Time'
  },
  {
    value: 'ACST',
    title: 'Australian Central Standard Time'
  },
  {
    value: 'AWST',
    title: 'Australian Central Western Standard Time'
  },
  {
    value: 'BJT',
    title: 'Beijing Time'
  },
  {
    value: 'EST',
    title: 'US Eastern Time'
  },
  {
    value: 'MST',
    title: 'US Mountain Time'
  },
  {
    value: 'CST',
    title: 'US Central Time'
  },
  {
    value: 'PST',
    title: 'US Pacific Time'
  },
  {
    value: 'SAST',
    title: 'South Africa Time'
  },
  {
    value: 'BST',
    title: 'British Time'
  },
  {
    value: 'FST',
    title: 'French Time'
  },
  {
    value: 'TST',
    title: 'Thailand Time'
  }
]

export const packageModule = [
  ['MODULE_1', 'Module 1  Kickoff+Activity List Guidance'],
  ['MODULE_2', 'Module 2  PS Brainstorming'],
  ['MODULE_3', 'Module 3  Supplemental Easays Brainstorming'],
  ['MODULE_6', 'Module 6  Comprehensive Support (CS) Hours'],
  ['MODULE_7', 'FAO Mock Review'],
  ['LONG_TERM', 'Long-term Planning Module']
]
// COACH ---- 模块6, lONG_TERM
// ESSAY_CHATS----模块1-3,
// FAO_ESSAY_CHATS-----模块1-3
// FAO_COACH----模块7
// lONG_TERM---长线服务包

export function operPackageModule (item) {
  let appointTypes = item.ugdAppointmentTypes
  let tempArr = []
  if (appointTypes.length === 0) {
    return []
  }
  if (
    appointTypes.length > 0 &&
    (appointTypes.includes('ESSAY_CHATS') ||
      appointTypes.includes('FAO_ESSAY_CHATS'))
  ) {
    tempArr.push({
      id: 'MODULE_1',
      name: 'Module 1  Kickoff+Activity List Guidance',
      checked: false
    })
    tempArr.push({
      id: 'MODULE_2',
      name: 'Module 2  PS Brainstorming',
      checked: false
    })
    tempArr.push({
      id: 'MODULE_3',
      name: 'Module 3  Supplemental Easays Brainstorming',
      checked: false
    })
  }
  if (appointTypes.length > 0 && appointTypes.includes('COACH')) {
    tempArr.push({
      id: 'MODULE_6',
      name: 'Module 6  Comprehensive Support (CS) Hours',
      checked: false
    })
    tempArr.push({
      id: 'LONG_TERM',
      name: 'Long-term Planning Module',
      checked: false
    })
  }
  if (appointTypes.length > 0 && appointTypes.includes('FAO_COACH')) {
    tempArr.push({ id: 'MODULE_7', name: 'FAO Mock Review', checked: false })
  }
  // if (appointTypes.length > 0 && appointTypes.includes('lONG_TERM')) {
  //   tempArr.push({
  //     id: 'lONG_TERM',
  //     name: 'Long-term Planning Module',
  //     checked: false
  //   })
  // }
  return tempArr
}
